var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1901_16041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 14.625V4.5C2.75 4.35082 2.80926 4.20774 2.91475 4.10225C3.02024 3.99676 3.16332 3.9375 3.3125 3.9375H7.06227C7.18397 3.9375 7.3024 3.97697 7.39977 4.05L9.5 5.625H14.5625C14.7117 5.625 14.8548 5.68426 14.9602 5.78975C15.0657 5.89524 15.125 6.03832 15.125 6.1875V7.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 14.625L4.87203 8.25961C4.90937 8.14761 4.981 8.05019 5.07678 7.98116C5.17257 7.91213 5.28764 7.87499 5.4057 7.875H16.8125C16.9016 7.87499 16.9895 7.89617 17.0688 7.93678C17.1482 7.97739 17.2167 8.03628 17.2689 8.10859C17.321 8.1809 17.3552 8.26456 17.3686 8.35267C17.382 8.44078 17.3744 8.53083 17.3462 8.61539L15.3423 14.625H2.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1901_16041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceFileIcon);
export default __webpack_public_path__ + "static/media/Invoice File Icon.d5a6e790bb6c9d170c085ac05eb62365.svg";
export { ForwardRef as ReactComponent };